import React from 'react'

import { useAsyncError, useRevalidator } from 'react-router-dom'

import { AppContext } from '@/components/base/appcontext'

import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'

import { RotateCcw } from 'lucide-react'

interface LoaderError {
    data: string
    init: {
        status: number
    }
}

function ErrorComponentLoading() {
    const appContext = React.useContext(AppContext)
    const revalidator = useRevalidator()
    const error = useAsyncError() as LoaderError

    React.useEffect(() => {
        console.error('Loader error:', error)
    }, [error])

    return (
        <Alert className="m-2 rounded-lg">
            <div className="col-span-2 flex items-center w-full gap-2">
                <span>🤔</span>
                <Typography
                    variant="title-sm"
                    textAlign="center"
                    className="text-destructive flex-1"
                >
                    {appContext.geti18n('base.error.title.text')}
                </Typography>
                <Button
                    variant="ghost"
                    size="icon"
                    disabled={revalidator.state !== 'idle'}
                    onClick={() => revalidator.revalidate()}
                >
                    <RotateCcw className="h-4 w-4 text-yellow-500" />
                </Button>
            </div>
        </Alert>
    )
}

export default ErrorComponentLoading
